import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPayersMutationVariables = Types.Exact<{
  input: Types.AddPayersInput;
}>;


export type AddPayersMutation = { readonly __typename?: 'Mutation', readonly addPayers?: { readonly __typename?: 'Invoice', readonly _id: string, readonly payers: ReadonlyArray<{ readonly __typename?: 'Payer', readonly type: Types.PayerType, readonly name: string, readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null }, readonly insuranceDetails?: { readonly __typename?: 'InsuranceDetails', readonly name?: string | null, readonly insuranceNumber?: string | null, readonly nationalIdNumber?: string | null, readonly dependent?: Types.Dependent | null } | null }> } | null };


export const AddPayersDocument = gql`
    mutation addPayers($input: AddPayersInput!) {
  addPayers(input: $input) {
    _id
    payers {
      type
      name
      balance {
        total
        paid
        due
      }
      insuranceDetails {
        name
        insuranceNumber
        nationalIdNumber
        dependent
      }
    }
  }
}
    `;
export type AddPayersMutationFn = Apollo.MutationFunction<AddPayersMutation, AddPayersMutationVariables>;

/**
 * __useAddPayersMutation__
 *
 * To run a mutation, you first call `useAddPayersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPayersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPayersMutation, { data, loading, error }] = useAddPayersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPayersMutation(baseOptions?: Apollo.MutationHookOptions<AddPayersMutation, AddPayersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPayersMutation, AddPayersMutationVariables>(AddPayersDocument, options);
      }
export type AddPayersMutationHookResult = ReturnType<typeof useAddPayersMutation>;
export type AddPayersMutationResult = Apollo.MutationResult<AddPayersMutation>;
export type AddPayersMutationOptions = Apollo.BaseMutationOptions<AddPayersMutation, AddPayersMutationVariables>;